"use client";
import { Inter } from "next/font/google";

import "./globals.css";
import "animate.css";

import { PropsWithChildren } from "react";
import { ReduxProvider } from "./redux/config/provider";
import PageLoader from "@/components/pageLoader/page-loader";
import { SessionProvider } from "next-auth/react";
import "@splidejs/react-splide/css";
import TermConditionConfirmationModal from "@/components/modal/TermConditionConfirmationModal";

import {
  helveticaNowDisplayRegular,
  helveticaNowDisplayBold,
  helveticaNowDisplayMedium,
  helveticaNowDisplayLight,
  helveticaNowDisplayThin,
} from "./_font/fonts";

//import SEO from "@/components/SEO";

// export const metadata = {
//   title: "WWS E-commerce",
//   description: "a ecomm website",
// };

export default function RootLayout({ children }: PropsWithChildren) {
  return (
    <html
      lang="en"
      className={`
      ${helveticaNowDisplayRegular.variable}
      ${helveticaNowDisplayBold.variable}
      ${helveticaNowDisplayMedium.variable}
      ${helveticaNowDisplayLight.variable}
      ${helveticaNowDisplayThin.variable}
    `}
    >
      <head>
        <link rel="icon" href="/favicon.ico" sizes="any" />
        {/* <script async defer src="https://tools.luckyorange.com/core/lo.js?site-id=55366b9c"></script> */}
      </head>
      <body>
        {/* <SEO /> */}
        <ReduxProvider>
          <PageLoader />
          <TermConditionConfirmationModal />
          <SessionProvider>{children}</SessionProvider>
        </ReduxProvider>

        {/* {children} */}

        <div className="absolute z-[9999] debug left-0  bottom-0"></div>
      </body>
    </html>
  );
}
